export default __webpack_public_path__ + "static/media/HAAS_Alert.f1e610e1.jpg";